module.exports = __webpack_public_path__ + "img/almalinux.d45afe0e.svg";